<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h3>Account Managers</h3>
      </v-flex>

      <v-flex lg12 xl5>
        <p>Options by Sender</p>
        <v-data-table
          :headers="senderHeaders"
          :items="senderData"
          hide-actions
          class="elevation-1"
          id="options-by-sender"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.totalAccounts }}</td>
            <td>{{ props.item.uniqueAccounts }}</td>
            <td>{{ props.item.orders }}</td>
            <td>{{ props.item.total }}</td>
            <td>{{ props.item.accepted }}</td>
            <td>{{ getCloseRate(props.item) }}%</td>
            <td>{{ parseInt(props.item.averageDuration) }}</td>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex lg12 xl5 offset-xl1>
        <p>Options sent by Industry</p>
        <v-data-table
          :headers="industryHeaders"
          :items="senderIndustryData"
          hide-actions
          class="elevation-1"
          id="options-by-industry"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.uniqueAccounts }}</td>
            <td>{{ props.item.orders }}</td>
            <td>{{ props.item.total }}</td>
            <td>{{ props.item.accepted }}</td>
            <td>{{ getCloseRate(props.item) }}%</td>
            <td>{{ parseInt(props.item.averageDuration) }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AmTable',
  props: ['senderData', 'senderIndustryData'],
  data() {
    return {
      senderHeaders: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Total Accounts',
          value: 'totalAccounts'
        },
        {
          text: 'Active Accounts',
          value: 'uniqueAccounts'
        },
        {
          text: 'Orders',
          value: 'orders'
        },
        {
          text: 'Options',
          value: 'total'
        },
        {
          text: 'Accepts',
          value: 'accepted'
        },
        {
          text: 'Close Rate',
          value: 'closeRate',
          sortable: false
        },
        {
          text: 'Average Duration (minutes)',
          value: 'averageDuration'
        }
      ],
      industryHeaders: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Active Accounts',
          value: 'uniqueAccounts'
        },
        {
          text: 'Orders',
          value: 'orders'
        },
        {
          text: 'Options',
          value: 'total'
        },
        {
          text: 'Accepts',
          value: 'accepted'
        },
        {
          text: 'Close Rate',
          value: 'closeRate',
          sortable: false
        },
        {
          text: 'Average Duration (minutes)',
          value: 'averageDuration'
        }
      ]
    };
  },
  methods: {
    getCloseRate(sender) {
      return ((sender.accepted / sender.orders) * 100).toFixed(1);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/options/AmTable.vue